import React, { FC } from 'react';
import { useLazyQuery } from '@apollo/client';

import Button from 'vibo-ui/Button';

import { IconmoonFont } from 'vibo-ui/Icon';

import { onError } from 'graphql/helpers';
import { toastNotify } from 'graphql/hooks/common';
import { downloadCsvFromBase64 } from './constants';
import { useUsersFilterable } from 'pages/admin/Users/UsersListContext';

import { EXPORT_USERS_CSV } from 'graphql/queries/admin';

const ExportUsersCSVButton: FC = () => {
  const { filter } = useUsersFilterable();

  const [exportUsersCsv, { loading }] = useLazyQuery(EXPORT_USERS_CSV, {
    onCompleted: ({ exportUsersCsv }) => {
      if (exportUsersCsv) {
        downloadCsvFromBase64(exportUsersCsv);
        toastNotify({ text: 'Users exported!' });
      }
    },
    onError,
  });

  const handleExportUsersCsv = () => {
    exportUsersCsv({
      variables: {
        filter,
      },
    });
  };

  return (
    <Button
      onClick={handleExportUsersCsv}
      loading={loading}
      prefixIcon={IconmoonFont['share-arrow-16']}
      size="lg"
      shape="round"
    >
      Export to CSV
    </Button>
  );
};

export default ExportUsersCSVButton;
